<template>
  <div class="TermsOfService" v-if="termsOfServiceshow">
    <div class="title">▎用户注册协议</div>
    <div class="notice" v-html="userInfoText || text"></div>
    <div class="footer">
      <el-button @click="termsOfServiceEvent">确定</el-button>
    </div>
  </div>
</template>

<script>
import { page } from '@/api/login.js'
import { config } from '@/constant/config'

export default {
  props: ['termsOfServiceshow', 'userInfoText'],
  data () {
    return {
      text: ''
    }
  },
  created () {
    this.$nextTick(() => {
      if (!this.userInfoText) {
        this.page()
      }
    })
  },
  methods: {
    termsOfServiceEvent () {
      this.$emit('termsOfServiceEvent')
    },
    page () {
      page({
        limit: 10,
        page: 1,
        protocolName: '用户使用协议'
      }).then((res) => {
        if (res.code === 0) {
          if (res.data.list.length > 0) {
            res.data.list[0].protocolContent = res.data.list[0].protocolContent ? res.data.list[0].protocolContent.replace('<img class="wscnph" src="', '<img class="wscnph" src="' + config.BASE_URL + '/') : ''
            if (res.data.list[0].protocolContent) {
              const regExp = new RegExp('<img src="/file/download/', 'g')
              res.data.list[0].protocolContent = res.data.list[0].protocolContent.replace(regExp, `<img src="${config.BASE_URL}/file/download/`)
              res.data.list[0].protocolContent = res.data.list[0].protocolContent.replace(/\<img/gi, '<img style="max-width:96%;display:block;height:auto;margin:0 2%;"')
            }
            this.text = res.data.list[0].protocolContent
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.TermsOfService {
  position: fixed;
  top: 50%;
  left: 50%;
  /* transition: trs; */
  transform: translate(-50%, -50%);
  z-index: 2000;
  background: white;
  border: 2px solid #d3d3d3;
  width: 800px;
  height: 700px;
  border-radius: 10px;
  .curter {
    cursor: pointer;
  }
  .footer {
    text-align: center;
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
  .notice {
    padding: 20px 20px 60px 20px;
    overflow: auto;
    height: 520px;
  }
  .title {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    line-height: 44px;
    height: 44px;
    padding-left: 20px;
    padding-top: 10px;
  }
}
</style>
